import { useCallback, useRef } from 'react';

import { useStores } from '../stores/useStores';

export function useMissedCountrySettings() {
  const {
    userStore: { profile },
  } = useStores();

  const isCountrySetAlreadyShowed = useRef(false);

  const checkCountrySetMissed = useCallback(() => {
    if (profile && !profile.isCountrySetByUser && !isCountrySetAlreadyShowed.current) {
      isCountrySetAlreadyShowed.current = true;
      return true;
    }
    return false;
  }, [profile]);

  return { checkCountrySetMissed };
}
